(function () {
  var STAR =
    '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M8 1.15l1.76 3.82 4.18.46-3.14 2.86.86 4.16L8 10.4l-3.66 2.05.86-4.16L2.06 5.43l4.18-.46L8 1.15z"></path></svg>';
  var VERIFIED_ICON =
    'https://cdn.shopify.com/s/files/1/0990/7657/1421/files/verified-symbol-icon.svg?v=1789747104';
  var SORTS = [
    { id: 'helpful', label: 'Most Helpful', value: 'most_helpful' },
    { id: 'latest', label: 'Latest', value: 'created_at' },
    { id: 'positive', label: 'Positive', value: 'highest_rating' },
    { id: 'negative', label: 'Negative', value: 'lowest_rating' },
  ];
  var cache = {};
  var scrollLock = null;

  function text(node) {
    return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function httpsUrl(value) {
    return typeof value === 'string' && /^https:\/\//i.test(value) ? value : '';
  }

  function formatScore(value) {
    if (value == null || !isFinite(value)) return '';
    return (Math.round(value * 10) / 10).toFixed(1);
  }

  function formatDate(value) {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || '');
    if (iso) return Number(iso[3]) + ' ' + months[Number(iso[2]) - 1] + ' ' + iso[1];
    var us = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(value || '');
    if (us) return Number(us[2]) + ' ' + months[Number(us[1]) - 1] + ' ' + us[3];
    return value || '';
  }

  function keyOf(review) {
    return [review.name || '', review.title || '', (review.body || '').slice(0, 48)].join('|');
  }

  function compactCountry(code, name) {
    var labels = { US: 'USA', USA: 'USA', GB: 'UK', UK: 'UK', AE: 'UAE' };
    var key = String(code || '').trim().toUpperCase();
    if (labels[key]) return labels[key];
    var named = String(name || '').trim();
    if (!named) return '';
    if (/^united states( of america)?$/i.test(named)) return 'USA';
    if (/^united kingdom$/i.test(named)) return 'UK';
    if (/^united arab emirates$/i.test(named)) return 'UAE';
    return named;
  }

  function remember(review) {
    if (!review) return review;
    var key = keyOf(review);
    var prev = cache[key] || {};
    var photos = review.photos && review.photos.length ? review.photos : prev.photos || [];
    cache[key] = {
      id: review.id || prev.id || key,
      name: review.name || prev.name || '',
      title: review.title || prev.title || '',
      body: review.body || prev.body || '',
      rating: review.rating != null ? review.rating : prev.rating,
      date: review.date || prev.date || '',
      verified: review.verified === true || prev.verified === true,
      variant: review.variant || prev.variant || '',
      country: review.country || prev.country || '',
      photos: photos.filter(httpsUrl),
    };
    return cache[key];
  }

  function stars(rating, scale) {
    var wrap = document.createElement('span');
    wrap.className = 'gf-cr__stars';
    var max = scale > 0 ? scale : 5;
    var full = rating == null ? 0 : Math.round(rating);
    if (full < 0) full = 0;
    if (full > max) full = max;
    for (var i = 1; i <= max; i++) {
      var star = document.createElement('span');
      star.className = 'gf-cr__star' + (i <= full ? ' is-on' : ' is-off');
      star.innerHTML = STAR;
      wrap.appendChild(star);
    }
    if (rating != null) {
      var score = document.createElement('span');
      score.className = 'gf-cr__score';
      score.textContent = formatScore(rating);
      wrap.appendChild(score);
      var spoken = document.createElement('span');
      spoken.className = 'visually-hidden';
      spoken.textContent = formatScore(rating) + ' out of ' + max + ' stars.';
      wrap.appendChild(spoken);
    }
    return wrap;
  }

  function ratingBadge(rating) {
    var badge = document.createElement('span');
    badge.className = 'gf-cr-badge';
    badge.insertAdjacentHTML('beforeend', STAR);
    var score = document.createElement('span');
    score.textContent = formatScore(rating);
    badge.appendChild(score);
    var spoken = document.createElement('span');
    spoken.className = 'visually-hidden';
    spoken.textContent = formatScore(rating) + ' out of 5 stars.';
    badge.appendChild(spoken);
    return badge;
  }

  function summaryStars(score) {
    var wrap = document.createElement('span');
    wrap.className = 'gf-cr-summary__stars';
    wrap.setAttribute('aria-hidden', 'true');
    var base = document.createElement('span');
    base.className = 'gf-cr-summary__base';
    var fill = document.createElement('span');
    fill.className = 'gf-cr-summary__fill';
    var value = isFinite(score) ? Math.max(0, Math.min(5, score)) : 0;
    fill.style.width = (value / 5) * 100 + '%';
    var row = document.createElement('span');
    for (var i = 0; i < 5; i++) {
      base.insertAdjacentHTML('beforeend', STAR);
      row.insertAdjacentHTML('beforeend', STAR);
    }
    fill.appendChild(row);
    wrap.appendChild(base);
    wrap.appendChild(fill);
    return wrap;
  }

  function productPack(source) {
    var root = source.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
    var id = root && (root.getAttribute('data-product-id') || root.getAttribute('data-id'));
    var data = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget;
    return { id: id, pack: id && data ? data[id] : null };
  }

  function readData(pack) {
    if (!pack || !pack.reviews) return;
    pack.reviews.forEach(function (review) {
      remember({
        id: review.uuid,
        name: review.reviewer_name || '',
        title: review.title || '',
        body: review.body || '',
        rating: typeof review.rating === 'number' ? review.rating : null,
        date: review.created_at || '',
        verified: review.verified_buyer === true,
        variant: review.product_variant_title || '',
        country: compactCountry(review.location_country_code, review.location_country || review.location),
        photos: (review.pictures_urls || []).map(httpsUrl).filter(Boolean),
      });
    });
  }

  function readDom(source) {
    var nodes = source.querySelectorAll('.jm-review-item, .jdgm-rev');
    var list = [];
    Array.prototype.forEach.call(nodes, function (node) {
      var ratingNode = node.querySelector('.jm-star-rating, .jdgm-rev__rating');
      var label = ratingNode ? ratingNode.getAttribute('aria-label') || '' : '';
      var ratingMatch = label.match(/([\d.]+)/);
      var rating = ratingMatch ? Number(ratingMatch[1]) : null;
      if (rating == null && ratingNode && ratingNode.getAttribute('data-score')) {
        rating = Number(ratingNode.getAttribute('data-score'));
      }
      var name = text(node.querySelector('.jm-reviewer-info__name, .jdgm-rev__author'));
      var title = text(node.querySelector('.jm-review-content__title, .jdgm-rev__title'));
      var body = text(node.querySelector('.jdgm-review-content__body-content, .jm-review-content__body, .jdgm-rev__body'));
      var date = '';
      var time = node.querySelector('time');
      if (time) date = time.getAttribute('datetime') || text(time);
      if (!date) {
        var bits = node.querySelectorAll('.jm-reviewer-info__details .jm-text');
        Array.prototype.forEach.call(bits, function (bit) {
          var value = text(bit);
          if (!date && value && value !== name && /\d/.test(value) && value.length < 24) date = value;
        });
      }
      var photos = [];
      Array.prototype.forEach.call(node.querySelectorAll('img'), function (img) {
        var src = httpsUrl(img.currentSrc || img.src);
        if (!src || /verified|logo|star|avatar/i.test(src)) return;
        photos.push(src);
      });
      list.push(
        remember({
          name: name,
          title: title,
          body: body,
          rating: rating,
          date: date,
          verified: false,
          variant: '',
          photos: photos,
        })
      );
    });
    return list;
  }

  function knownReviews() {
    return Object.keys(cache).map(function (key) {
      return cache[key];
    });
  }

  function photoCount() {
    return knownReviews().filter(function (review) {
      return review.photos.length;
    }).length;
  }

  function sizes() {
    var found = {};
    knownReviews().forEach(function (review) {
      if (review.variant) found[review.variant] = true;
    });
    return Object.keys(found);
  }

  function lockPage() {
    if (scrollLock) return;
    scrollLock = {
      html: document.documentElement.style.overflow,
      body: document.body.style.overflow,
    };
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function unlockPage() {
    if (!scrollLock) return;
    document.documentElement.style.overflow = scrollLock.html;
    document.body.style.overflow = scrollLock.body;
    scrollLock = null;
  }

  function appendBody(parent, review) {
    if (review.body && review.body !== review.title) {
      var body = document.createElement('p');
      body.className = 'gf-cr-card__body';
      body.textContent = review.body;
      parent.appendChild(body);
    }
  }

  function identity(review) {
    var foot = document.createElement('div');
    foot.className = 'gf-cr-card__foot';
    var who = document.createElement('p');
    who.className = 'gf-cr-card__who';
    var named = false;
    if (review.verified === true) {
      var mark = document.createElement('img');
      mark.className = 'gf-cr__verified';
      mark.src = VERIFIED_ICON;
      mark.alt = '';
      mark.width = 16;
      mark.height = 16;
      who.appendChild(mark);
      var spoken = document.createElement('span');
      spoken.className = 'visually-hidden';
      spoken.textContent = 'Verified buyer ';
      who.appendChild(spoken);
      named = true;
    }
    var label = review.name || '';
    if (review.country) label = label ? label + ' | ' + review.country : review.country;
    if (label) {
      who.appendChild(document.createTextNode(label));
      named = true;
    }
    if (named) foot.appendChild(who);
    if (review.variant) {
      var size = document.createElement('p');
      size.className = 'gf-cr-card__size';
      size.textContent = 'Size Bought: ' + review.variant;
      foot.appendChild(size);
    }
    return foot.childNodes.length ? foot : null;
  }

  function driveSort(sort, value) {
    sort.value = value;
    var symbols = Object.getOwnPropertySymbols(sort);
    var marker = null;
    for (var i = 0; i < symbols.length; i++) {
      if (String(symbols[i]).indexOf('_vei') !== -1) marker = symbols[i];
    }
    var handlers = marker && sort[marker];
    if (handlers && typeof handlers.onChange === 'function') {
      handlers.onChange({ target: sort });
      return;
    }
    sort.dispatchEvent(new Event('input', { bubbles: true }));
    sort.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function card(review, compact) {
    var article = document.createElement('article');
    article.className = 'gf-cr-card' + (compact ? ' gf-cr-card--carousel' : '');
    var top = document.createElement('div');
    top.className = 'gf-cr-card__top';
    if (review.rating != null) top.appendChild(ratingBadge(review.rating));
    if (review.title) {
      var title = document.createElement('p');
      title.className = 'gf-cr-card__title';
      title.textContent = review.title;
      top.appendChild(title);
    }
    var date = formatDate(review.date);
    if (date) {
      var time = document.createElement('time');
      time.className = 'gf-cr-card__date';
      time.textContent = date;
      if (review.date) time.setAttribute('datetime', review.date);
      top.appendChild(time);
    }
    article.appendChild(top);
    appendBody(article, review);

    if (review.photos.length && !compact) {
      var photos = document.createElement('div');
      photos.className = 'gf-cr-card__photos';
      review.photos.forEach(function (src, index) {
        photos.appendChild(photoButton(review, index));
      });
      article.appendChild(photos);
    }

    var foot = identity(review);
    if (foot) article.appendChild(foot);
    return article;
  }

  function photoButton(review, index) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'gf-cr__photo';
    button.setAttribute('aria-label', 'Open review photo ' + (index + 1));
    var img = document.createElement('img');
    img.src = review.photos[index];
    img.alt = '';
    button.appendChild(img);
    button.addEventListener('click', function () {
      openLightbox(review, index);
    });
    return button;
  }

  var lightbox = null;
  var modal = null;
  var lightboxReturn = null;

  function ensureLightbox() {
    if (lightbox) return lightbox;
    var root = document.createElement('div');
    root.className = 'gf-cr-lightbox';
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Review photo');
    root.innerHTML =
      '<div class="gf-cr-lightbox__overlay" data-gf-cr-lightbox-close></div>' +
      '<button type="button" class="gf-cr-lightbox__close" aria-label="Close photo">×</button>' +
      '<button type="button" class="gf-cr-lightbox__nav gf-cr-lightbox__nav--prev" aria-label="Previous photo">‹</button>' +
      '<button type="button" class="gf-cr-lightbox__nav gf-cr-lightbox__nav--next" aria-label="Next photo">›</button>' +
      '<p class="gf-cr-lightbox__count" data-gf-cr-lightbox-count></p>' +
      '<figure class="gf-cr-lightbox__figure"><img alt=""></figure>' +
      '<div class="gf-cr-lightbox__panel" data-gf-cr-lightbox-panel></div>';
    document.body.appendChild(root);
    var state = { review: null, index: 0 };
    var img = root.querySelector('img');
    var count = root.querySelector('[data-gf-cr-lightbox-count]');
    var prev = root.querySelector('.gf-cr-lightbox__nav--prev');
    var next = root.querySelector('.gf-cr-lightbox__nav--next');
    var panel = root.querySelector('[data-gf-cr-lightbox-panel]');

    function paint() {
      var photos = state.review.photos;
      img.src = photos[state.index];
      img.alt = 'Customer review photo ' + (state.index + 1);
      var many = photos.length > 1;
      prev.hidden = !many;
      next.hidden = !many;
      count.hidden = !many;
      count.textContent = state.index + 1 + '/' + photos.length;
      panel.textContent = '';
      var top = document.createElement('div');
      top.className = 'gf-cr-card__top';
      if (state.review.rating != null) top.appendChild(ratingBadge(state.review.rating));
      if (state.review.title) {
        var title = document.createElement('p');
        title.className = 'gf-cr-card__title';
        title.textContent = state.review.title;
        top.appendChild(title);
      }
      var dateLabel = formatDate(state.review.date);
      if (dateLabel) {
        var time = document.createElement('time');
        time.className = 'gf-cr-card__date';
        time.textContent = dateLabel;
        top.appendChild(time);
      }
      panel.appendChild(top);
      appendBody(panel, state.review);
      var foot = identity(state.review);
      if (foot) panel.appendChild(foot);
    }

    function step(delta) {
      if (!state.review || state.review.photos.length < 2) return;
      var total = state.review.photos.length;
      state.index = (state.index + delta + total) % total;
      paint();
    }

    function close() {
      root.hidden = true;
      img.removeAttribute('src');
      state.review = null;
      if (!modal || modal.root.hidden) unlockPage();
      if (lightboxReturn) lightboxReturn.focus();
    }

    root.querySelector('.gf-cr-lightbox__close').addEventListener('click', close);
    root.querySelector('[data-gf-cr-lightbox-close]').addEventListener('click', close);
    prev.addEventListener('click', function () {
      step(-1);
    });
    next.addEventListener('click', function () {
      step(1);
    });
    var touchX = null;
    root.addEventListener('touchstart', function (event) {
      touchX = event.changedTouches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', function (event) {
      if (touchX == null) return;
      var delta = event.changedTouches[0].clientX - touchX;
      if (Math.abs(delta) > 40) step(delta < 0 ? 1 : -1);
      touchX = null;
    }, { passive: true });

    lightbox = { root: root, close: close, isOpen: function () { return !root.hidden; }, show: function (review, index) {
      state.review = review;
      state.index = index;
      paint();
      root.hidden = false;
      lockPage();
      root.querySelector('.gf-cr-lightbox__close').focus();
    } };
    return lightbox;
  }

  function openLightbox(review, index) {
    lightboxReturn = document.activeElement;
    ensureLightbox().show(review, index);
  }

  function ensureModal(api) {
    if (modal) return modal;
    var root = document.createElement('div');
    root.className = 'gf-cr-modal';
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'gf-cr-modal-title');
    root.innerHTML =
      '<div class="gf-cr-modal__overlay" data-gf-cr-modal-close></div>' +
      '<div class="gf-cr-modal__panel">' +
      '<div class="gf-cr-modal__bar"><h2 id="gf-cr-modal-title" class="gf-cr-modal__title">All Reviews</h2>' +
      '<button type="button" class="gf-cr-modal__close" aria-label="Close reviews">×</button></div>' +
      '<div class="gf-cr-modal__summary" data-gf-cr-modal-summary></div>' +
      '<div class="gf-cr-modal__sorts" data-gf-cr-modal-sorts></div>' +
      '<div class="gf-cr-modal__list" data-gf-cr-modal-list tabindex="-1"></div>' +
      '</div>';
    document.body.appendChild(root);
    var state = { filter: 'all', size: '', sort: '' };
    function close() {
      root.hidden = true;
      if (!lightbox || !lightbox.isOpen()) unlockPage();
      var opener = document.querySelector('[data-gf-cr-see-all]');
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
        opener.focus();
      }
    }
    root.querySelector('.gf-cr-modal__close').addEventListener('click', close);
    root.querySelector('[data-gf-cr-modal-close]').addEventListener('click', close);
    modal = {
      root: root,
      state: state,
      close: close,
      isOpen: function () {
        return !root.hidden;
      },
      open: function () {
        root.hidden = false;
        lockPage();
        var opener = document.querySelector('[data-gf-cr-see-all]');
        if (opener) opener.setAttribute('aria-expanded', 'true');
        root.querySelector('.gf-cr-modal__close').focus();
        api.paintModal();
      },
    };
    return modal;
  }

  function bind(section) {
    if (!section || section.getAttribute('data-gf-cr-bound') === 'true') return;
    var source = section.querySelector('[data-gf-cr-source]');
    var items = source && source.querySelectorAll('.jm-review-item, .jdgm-rev');
    if (!source || !items || !items.length) return;
    section.setAttribute('data-gf-cr-bound', 'true');
    section.classList.add('gf-cr--ready');
    source.setAttribute('aria-hidden', 'true');
    source.setAttribute('inert', '');

    var countNode = section.querySelector('[data-gf-cr-count]');
    var photosEl = section.querySelector('[data-gf-cr-photos]');
    var cardsEl = section.querySelector('[data-gf-cr-cards]');
    var button = section.querySelector('[data-gf-cr-see-all]');
    var ui = ensureModal({
      paintModal: function () {
        paintModal();
      },
    });

    var ordered = [];
    var preview = [];
    var collecting = false;
    var resumeCollect = null;
    var pageGuard = 0;
    var collectToken = 0;

    function currentList() {
      var found = productPack(source);
      readData(found.pack);
      return readDom(source);
    }

    function summaryCount() {
      var found = productPack(source);
      if (found.pack && found.pack.number_of_reviews) return found.pack.number_of_reviews;
      return currentList().length;
    }

    function pageControls() {
      return source.querySelectorAll('.jm-pagination-controls button, .jdgm-paginate__page');
    }

    function nextControl() {
      var pages = pageControls();
      for (var i = 0; i < pages.length; i++) {
        var label = pages[i].getAttribute('aria-label') || '';
        if (/next/i.test(label) && !pages[i].disabled) return pages[i];
      }
      return null;
    }

    function pageOneControl() {
      var pages = pageControls();
      for (var i = 0; i < pages.length; i++) {
        var label = pages[i].getAttribute('aria-label') || '';
        if (/page\s*1\b/i.test(label) && pages[i].getAttribute('aria-current') !== 'page') return pages[i];
      }
      return null;
    }

    function unique(list) {
      var seen = {};
      var out = [];
      list.forEach(function (review) {
        var key = keyOf(review);
        if (!review || seen[key]) return;
        seen[key] = true;
        out.push(review);
      });
      return out;
    }

    function absorb() {
      var list = unique(currentList());
      if (!preview.length && list.length) preview = list.slice();
      list.forEach(function (review) {
        var key = keyOf(review);
        if (ordered.indexOf(key) === -1) ordered.push(key);
      });
      return list;
    }

    function allReviews() {
      var list = ordered.map(function (key) {
        return cache[key];
      }).filter(Boolean);
      return list.length ? list : currentList();
    }

    function finishCollect() {
      collecting = false;
      resumeCollect = null;
      paint();
    }

    function continueCollect() {
      var list = absorb();
      var total = summaryCount();
      var next = nextControl();
      var marker = list[0] ? keyOf(list[0]) : '';
      paintCards(unique(preview.length ? preview : list));
      if (!ui.root.hidden) paintModal();
      if (ordered.length >= total || !next || pageGuard > 8) {
        finishCollect();
        return;
      }
      pageGuard += 1;
      collectToken += 1;
      var token = collectToken;
      next.click();
      function watchPage() {
        resumeCollect = function () {
          var now = currentList();
          var nowKey = now[0] ? keyOf(now[0]) : '';
          if (!now.length || nowKey === marker) {
            watchPage();
            return;
          }
          continueCollect();
        };
      }
      watchPage();
      setTimeout(function () {
        if (!collecting || collectToken !== token || !resumeCollect) return;
        resumeCollect = null;
        finishCollect();
      }, 1600);
    }

    function loadAll() {
      if (collecting) return;
      collecting = true;
      ordered = [];
      preview = [];
      pageGuard = 0;
      var first = pageOneControl();
      if (first) {
        first.click();
        resumeCollect = function () {
          continueCollect();
        };
        return;
      }
      resumeCollect = null;
      continueCollect();
    }

    function paintStrip(reviews) {
      var photos = [];
      reviews.forEach(function (review) {
        review.photos.forEach(function (src, index) {
          if (httpsUrl(src)) photos.push({ review: review, index: index });
        });
      });
      photosEl.textContent = '';
      if (!photos.length) {
        photosEl.hidden = true;
        return;
      }
      var shown = photos.length > 5 ? 4 : photos.length;
      photos.slice(0, shown).forEach(function (item) {
        photosEl.appendChild(photoButton(item.review, item.index));
      });
      if (photos.length > shown) {
        var extra = photos.length - shown;
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'gf-cr__photo gf-cr__more';
        more.textContent = '+' + extra;
        more.setAttribute('aria-label', extra + ' more review photos');
        more.addEventListener('click', function () {
          openLightbox(photos[shown].review, photos[shown].index);
        });
        photosEl.appendChild(more);
      }
      photosEl.hidden = false;
    }

    function paintCards(reviews) {
      cardsEl.textContent = '';
      reviews.forEach(function (review) {
        cardsEl.appendChild(card(review, true));
      });
      var has = reviews.length > 0;
      cardsEl.hidden = !has;
      button.hidden = !has;
    }

    function summaryNode() {
      var found = productPack(source);
      var pack = found.pack;
      if (!pack || !pack.number_of_reviews) return null;
      var average = parseFloat(pack.average_rating);
      var card = document.createElement('section');
      card.className = 'gf-cr-summary';
      card.setAttribute('aria-label', 'Rating summary');
      var left = document.createElement('div');
      left.className = 'gf-cr-summary__score';
      var number = document.createElement('p');
      number.className = 'gf-cr-summary__average';
      number.textContent = isFinite(average) ? formatScore(average) : '';
      left.appendChild(number);
      if (isFinite(average)) left.appendChild(summaryStars(average));
      var count = document.createElement('p');
      count.className = 'gf-cr-summary__count';
      count.textContent = pack.number_of_reviews + (pack.number_of_reviews === 1 ? ' review' : ' reviews');
      left.appendChild(count);
      card.appendChild(left);
      var rows = Array.isArray(pack.histogram) ? pack.histogram.filter(function (row) {
        return row && typeof row.rating === 'number' && typeof row.frequency === 'number';
      }) : [];
      if (rows.length) {
        var rule = document.createElement('span');
        rule.className = 'gf-cr-summary__rule';
        rule.setAttribute('aria-hidden', 'true');
        card.appendChild(rule);
        var right = document.createElement('div');
        right.className = 'gf-cr-summary__bars';
        rows.sort(function (a, b) { return b.rating - a.rating; });
        rows.forEach(function (row) {
          var line = document.createElement('div');
          line.className = 'gf-cr-summary__row';
          var label = document.createElement('span');
          label.textContent = String(row.rating);
          var track = document.createElement('span');
          track.className = 'gf-cr-summary__track';
          var bar = document.createElement('span');
          bar.className = 'gf-cr-summary__bar';
          var width = typeof row.percentage === 'number' ? row.percentage : 0;
          bar.style.width = Math.max(0, Math.min(100, width)) + '%';
          track.appendChild(bar);
          var freq = document.createElement('span');
          freq.textContent = String(row.frequency);
          line.appendChild(label);
          line.appendChild(track);
          line.appendChild(freq);
          right.appendChild(line);
        });
        card.appendChild(right);
      }
      return card;
    }

    function applySort(value) {
      var sort = source.querySelector('.jdgm-sort-dropdown');
      if (!sort || sort.value === value) return;
      var allowed = false;
      Array.prototype.forEach.call(sort.options, function (option) {
        if (option.value === value) allowed = true;
      });
      if (!allowed) return;
      var previous = currentList().map(keyOf).join('~');
      var token = collectToken + 1;
      collectToken = token;
      collecting = true;
      driveSort(sort, value);
      var tries = 0;
      function watch() {
        resumeCollect = function () {
          if (collectToken !== token) return;
          tries += 1;
          var now = currentList().map(keyOf).join('~');
          if (now === previous && tries < 8) {
            watch();
            return;
          }
          ordered = [];
          preview = [];
          pageGuard = 0;
          continueCollect();
        };
      }
      watch();
      setTimeout(function () {
        if (collectToken !== token || !collecting || !resumeCollect) return;
        resumeCollect = null;
        ordered = [];
        preview = [];
        pageGuard = 0;
        continueCollect();
      }, 1800);
    }

    function paintModal() {
      if (ui.root.hidden) return;
      var reviews = allReviews();
      var summary = ui.root.querySelector('[data-gf-cr-modal-summary]');
      var sorts = ui.root.querySelector('[data-gf-cr-modal-sorts]');
      var list = ui.root.querySelector('[data-gf-cr-modal-list]');
      var scrollTop = list.scrollTop;
      summary.textContent = '';
      var summaryCard = summaryNode();
      if (summaryCard) summary.appendChild(summaryCard);
      sorts.textContent = '';
      var sort = source.querySelector('.jdgm-sort-dropdown');
      var available = {};
      if (sort) {
        Array.prototype.forEach.call(sort.options, function (option) {
          available[option.value] = true;
        });
      }
      var supported = SORTS.filter(function (item) { return available[item.value]; });
      if (supported.length) {
        var heading = document.createElement('p');
        heading.className = 'gf-cr-modal__sort-label';
        heading.textContent = 'User reviews sorted by';
        sorts.appendChild(heading);
        var row = document.createElement('div');
        row.className = 'gf-cr-modal__sort-row';
        row.setAttribute('role', 'group');
        row.setAttribute('aria-label', 'User reviews sorted by');
        supported.forEach(function (item) {
          var control = document.createElement('button');
          control.type = 'button';
          control.className = 'gf-cr-modal__sort' + (sort && sort.value === item.value ? ' is-on' : '');
          control.setAttribute('aria-pressed', sort && sort.value === item.value ? 'true' : 'false');
          control.textContent = item.label;
          control.addEventListener('click', function () {
            applySort(item.value);
          });
          row.appendChild(control);
        });
        sorts.appendChild(row);
      }
      list.textContent = '';
      reviews.forEach(function (review) {
        list.appendChild(card(review, false));
      });
      list.scrollTop = scrollTop;
    }

    function paint() {
      if (collecting) return;
      var reviews = unique(preview.length ? preview : currentList());
      var total = summaryCount();
      if (total > 0) {
        countNode.hidden = false;
        countNode.textContent = '(' + total + ')';
      }
      paintStrip(allReviews());
      paintCards(reviews);
      paintModal();
    }

    button.addEventListener('click', function () {
      ui.open();
    });

    var timer = null;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (resumeCollect) {
          var nextStep = resumeCollect;
          resumeCollect = null;
          nextStep();
          return;
        }
        if (!collecting) paint();
      }, 80);
    });
    observer.observe(source, { childList: true, subtree: true, characterData: true });
    paint();
    loadAll();
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('[data-gf-cr]')) bind(scope);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-gf-cr]'), bind);
  }

  function watch() {
    boot(document);
    var pending = document.querySelector('[data-gf-cr]:not([data-gf-cr-bound])');
    if (!pending || pending.getAttribute('data-gf-cr-watching') === 'true') return;
    pending.setAttribute('data-gf-cr-watching', 'true');
    function settle() {
      boot(pending);
      var source = pending.querySelector('[data-gf-cr-source]');
      var found = source ? productPack(source) : { pack: null };
      if (found.pack && Number(found.pack.number_of_reviews) === 0) pending.classList.add('gf-cr--empty');
      if (pending.getAttribute('data-gf-cr-bound') === 'true' || pending.classList.contains('gf-cr--empty')) observer.disconnect();
    }
    var observer = new MutationObserver(settle);
    observer.observe(pending, { childList: true, subtree: true });
    settle();
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (lightbox && lightbox.isOpen()) {
      event.preventDefault();
      lightbox.close();
      return;
    }
    if (modal && modal.isOpen()) {
      event.preventDefault();
      modal.close();
    }
  });
  window.addEventListener('pagehide', unlockPage);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
    watch();
  });
})();
